import TableZoneList from "@/samples/jobchain/tables.json";
import { defineStore, storeToRefs } from "pinia";
import _ from "lodash";
import dayjs from "dayjs";
import PreviewBuilder from "~/class/PreviewBuilder";
import type { Table } from "~/interface/Table";


 
export const usePosTableListStore = defineStore("table-list", () => {

  const settingsStore = useSettingsStore()
//   const zoneList = ref([{
//     name : "A",
//     tableCount : 20
//   },
// {
//     name : "B",
//     tableCount : 10
//   }]);

   const zoneList = ref([ ]);

  zoneList.value = settingsStore.tables
  const zoneSelected = ref(zoneList.value[0]);  //object
  const mode = ref("table");  //table or delivery or togo or job

  // Remembers the table grid scroll offset across TableZone unmount (e.g. when
  // jumping to the cart/add flow and back), so the cashier returns to the same
  // spot instead of being reset to the top.
  const lastScrollTop = ref(0);


  const jobV1Store = usePosJobsStore();

  
 
  const activeTableList = computed(() => {
    const tables = jobV1Store.tables;

    let tableArray = [];
    for(const [key, table] of Object.entries(tables)){
      if(key!==undefined && table.mode == 1){
        tableArray.push({...table, name:key});
      }
    }
    return tableArray
  });

  return {
    zoneList,
    zoneSelected,
    activeTableList,
    mode,
    lastScrollTop,


  };
});
